class Menu {
  constructor (props) {
    this.menu = [
      {
        title: 'Dashboard',
        icon: 'fa-home',
        single: true,
        location: '#/access'
      }, {
        title: 'Search',
        icon: 'fa-search',
        single: true,
        location: '#/search'
      }
    ]
  }

  getMenu (endpoints) {
    if (endpoints.hasOwnProperty('users')) this.menu.push({ admin: true, title: 'Users', icon: 'fa-users', single: true, location: '#/users' })
    if (endpoints.hasOwnProperty('orders') && endpoints.orders.version === '2.4') this.menu.push({ title: 'Orders', icon: 'fa-first-order', single: true, location: '#/orders' })
    if (endpoints.hasOwnProperty('orderevents')) this.menu.push({ title: 'Order Events', icon: 'fa-sliders', single: true, location: '#/events' })
    if (endpoints.hasOwnProperty('tickets')) this.menu.push({ title: 'Tickets', icon: 'fa-ticket', enable: 'tickets', single: true, location: '#/ticket' })

    return this.menu
  }
}
export default new Menu()



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/config/menu.js